import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { getAuthProvider, SecurityService } from '@/core/services/security/security.service';
import { BootstrapService } from '@/core/services/bootstrap.service';
import { switchMap } from 'rxjs';
import { errorInterceptor } from '@/core/interceptors/error.interceptor';
import { authHttpInterceptorFn } from '@auth0/auth0-angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AclGuard } from '@/core/guards/acl.guard';

const appInitializer = () => {
    const bootstrapService = inject(BootstrapService);
    return bootstrapService.executePreAuth().pipe(
        switchMap(() => bootstrapService.executeAuth()),
        switchMap(() => bootstrapService.executePostAuth())
    );
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideAppInitializer(appInitializer),
        provideRouter(
            appRoutes,
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled'
            }),
            withEnabledBlockingInitialNavigation()
        ),
        AclGuard,
        SecurityService,
        BootstrapService,
        MessageService,
        ConfirmationService,
        getAuthProvider(),
        provideHttpClient(withFetch(), withInterceptors([errorInterceptor, authHttpInterceptorFn])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } })
    ]
};
